const BASE_PATH = '/maps';

const MAP_PATH = ':mapShareId';
const EXPIRED_PATH = 'expired';
const PDF_REPORT_ROUTE = 'pdf-report';

export const PublicMapPaths = {
  Base: `${BASE_PATH}/*`,
  Map: MAP_PATH,
  Expired: EXPIRED_PATH,
  PdfReport: PDF_REPORT_ROUTE,
} as const;

const _PUBLIC_MAP_ABSOLUTE_ROUTE = `${BASE_PATH}/${MAP_PATH}` as const;

export type PublicMapRoute = typeof _PUBLIC_MAP_ABSOLUTE_ROUTE;
